import React from 'react';
import PropTypes from 'prop-types';
import { StudentLearningGapsWrapper, Header, InfoContent, Body } from './styled';
import InfoTooltip from '../info-tooltip/info-tooltip';
import Doughnuts from '../doughnuts/doughnuts';
import { STUDENT } from '../doughnuts-inner/doughnuts-inner-hooks';
import AssignLearningJourneys from '../assign-learning-journeys/assign-learning-journeys';

const StudentLearningGaps = ({ student, i18n }) => {
  const { firstName, lastName, classroomPct, groupPct, studentPct, questions, id } = student;
  const studentName = `${firstName} ${lastName}`;
  const noQuestions = !(questions && questions.length);

  return (
    <StudentLearningGapsWrapper>
      <Header>
        <span>{studentName}</span>
        <InfoTooltip>
          <InfoContent>
            {i18n.t`Assign these activities to address individual student learning gaps.`}
          </InfoContent>
        </InfoTooltip>
      </Header>
      <Body>
        <Doughnuts
          i18n={i18n}
          data={{ resultType: STUDENT, groupPct, classroomPct, studentPct, studentName, noQuestions }}
        />
        <AssignLearningJourneys
          i18n={i18n}
          data={{ questions, showStudentLJ: true, studentId: id, studentName }}
        />
      </Body>
    </StudentLearningGapsWrapper>
  );
};

StudentLearningGaps.propTypes = {
  i18n: PropTypes.object,
  student: PropTypes.shape({
    classroomPct: PropTypes.number,
    groupPct: PropTypes.number,
    studentPct: PropTypes.number,
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    questions: PropTypes.array,
    learningJourneys: PropTypes.array
  })
};

export default StudentLearningGaps;
